/* ============================================================================
 * oak-finish-visualizer.js — stain picker for White Oak Inset (Special Order).
 *
 * The oak counterpart of the painted SW picker, and deliberately the same shape
 * so the two behave alike: pick once, the choice sticks, the photos follow it,
 * it rides to the cart as a line-item property, and nothing can be ordered
 * without it. The difference is the palette — six real stains, each shown by
 * its own sample photo rather than a colour chip, because that is what the
 * customer is actually choosing.
 *
 * The recolouring itself belongs to oak-box-visualizer.js, which already knows
 * how to tell the oak from the placeholder box in these renders. This file only
 * says WHICH finish is in force and asks for a repaint.
 * ==========================================================================*/
(function () {
  'use strict';

  var FINISHES = (window.OAK_FINISHES || []).filter(Boolean);
  if (!FINISHES.length) return;

  var CFG = window.OAK_FINISH_CONFIG || {};
  var REQUIRE = !!CFG.requireFinish;
  var SHOW_PICKER = !!CFG.showPicker;          // collection page only
  var KEY = 'rta_oak_finish';
  var PROP = 'Wood finish';
  // Sample doors and the legacy $0 colour-selection product may be bought
  // without a stain — a sample is HOW a shopper decides on one.
  var EXEMPT = {};
  (CFG.exemptVariantIds || []).forEach(function (id) {
    if (id) EXEMPT[String(id).trim()] = true;
  });
  function isExempt(form) {
    var el = form.querySelector('[name="id"]');
    return !!(el && EXEMPT[String(el.value).trim()]);
  }

  function byCode(code) {
    for (var i = 0; i < FINISHES.length; i++) if (FINISHES[i].code === code) return FINISHES[i];
    return null;
  }
  function load() {
    try { return byCode(localStorage.getItem(KEY)); } catch (e) { return null; }
  }
  function save(f) { try { localStorage.setItem(KEY, f.code); } catch (e) {} }
  function label(f) { return f.name + ' ' + f.code; }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  // Read by oak-box-visualizer.js on every render.
  window.OAK_FINISH_SELECTED = load();

  /* ---------- cart ------------------------------------------------------- */
  // Same rules as the painted side: written on a capture-phase submit, because
  // Dawn replaces the product form on every variant change and anything written
  // earlier goes with it.
  function setProp(form, key, value) {
    var name = 'properties[' + key + ']';
    var input = form.querySelector('input[name="' + name.replace(/"/g, '\\"') + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }
  // _Preview: the cabinet in this exact size and stain, Premium Box — a stored
  // image in Shopify Files (assets/oak-stain-images.js maps variant -> photo ->
  // stain image). Underscored so no template prints it as text; the cart,
  // order and invoice show it as the line's picture.
  function stainImage(form, f) {
    var map = window.OAK_STAIN_IMAGES;
    var el = form.querySelector('[name="id"]');
    if (!map || !el) return '';
    var photo = map.v[String(el.value).trim()];
    var set = photo && map.i[photo];
    return (set && set[f.code]) || '';
  }
  function injectCartProps() {
    var f = window.OAK_FINISH_SELECTED;
    if (!f) return;
    qsa('form[action*="/cart/add"]').forEach(function (form) {
      setProp(form, PROP, label(f));
      var img = stainImage(form, f);
      if (img) setProp(form, '_Preview', img);
      else {
        var old = form.querySelector('input[name="properties[_Preview]"]');
        if (old) old.parentNode.removeChild(old);
      }
    });
  }
  function saveToCart(f) {
    var attrs = {}; attrs[PROP] = label(f);
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  // "Buy it now" goes straight to checkout without submitting the form, so the
  // submit gate cannot see it. It is taken off the page until a finish exists.
  function syncPaymentButtons() {
    if (!REQUIRE) return;
    var forms = qsa('form[action*="/cart/add"]');
    // On a sample's own page every form is exempt, so leave the button alone.
    if (forms.length && forms.every(isExempt)) return;
    var blocked = !window.OAK_FINISH_SELECTED;
    qsa('.shopify-payment-button').forEach(function (el) {
      el.style.display = blocked ? 'none' : '';
    });
  }

  /* ---------- selection -------------------------------------------------- */
  function select(f) {
    window.OAK_FINISH_SELECTED = f;
    save(f);
    saveToCart(f);
    renderBar();
    markChosen();
    injectCartProps();
    syncPaymentButtons();
    if (window.OakBoxViz && window.OakBoxViz.refresh) window.OakBoxViz.refresh();
  }

  /* ---------- UI --------------------------------------------------------- */
  function styles() {
    if (document.getElementById('oak-finish-style')) return;
    var el = document.createElement('style');
    el.id = 'oak-finish-style';
    el.textContent = [
      '.oakf-picker{margin:0 0 28px;padding:18px;border:1px solid #e3ded4;border-radius:12px;background:#fbf9f6}',
      '.oakf-title{font-size:18px;font-weight:700;margin:0 0 4px}',
      '.oakf-sub{font-size:13px;color:#6f675c;margin:0 0 14px}',
      '.oakf-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(130px,1fr));gap:12px}',
      '.oakf-tile{border:2px solid #e3ded4;border-radius:10px;background:#fff;padding:0;cursor:pointer;overflow:hidden;text-align:left}',
      '.oakf-tile img{display:block;width:100%;aspect-ratio:13/15;object-fit:cover;background:#efe9e0}',
      '.oakf-tile figcaption{display:block;padding:8px 10px}',
      '.oakf-name{display:block;font-weight:600;font-size:14px}',
      '.oakf-code{display:block;font-size:12px;color:#6f675c}',
      '.oakf-tile[aria-pressed="true"]{border-color:#1c1a17;box-shadow:0 0 0 2px rgba(28,26,23,.15)}',
      '.oakf-note{margin:12px 0 0;font-size:12px;color:#6f675c}',
      '.oakf-bar{position:fixed;left:0;right:0;bottom:0;z-index:2147483000;display:flex;flex-wrap:wrap;',
      'align-items:center;gap:10px;padding:10px 16px;background:#1c1a17;color:#f3efe7;box-shadow:0 -2px 12px rgba(0,0,0,.25)}',
      '.oakf-bar[hidden]{display:none!important}',
      '.oakf-bar-sw{width:26px;height:26px;border-radius:5px;border:1px solid rgba(255,255,255,.3);object-fit:cover}',
      '.oakf-bar-label{font-size:13px;color:#b8b0a2}',
      '.oakf-bar-name{font-weight:600}',
      '.oakf-bar-code{color:#b8b0a2}',
      '.oakf-bar-need{font-weight:600;color:#e9c98a}',
      '.oakf-bar-cta{margin-left:auto;padding:7px 16px;border-radius:999px;background:#e9c98a;color:#1c1a17;',
      'font-weight:600;text-decoration:none;font-size:13px;border:0;cursor:pointer}',
      '.oakf-bar--alert{box-shadow:0 -2px 12px rgba(0,0,0,.25),inset 0 0 0 2px #e9c98a}'
    ].join('');
    document.head.appendChild(el);
  }

  function buildPicker() {
    if (!SHOW_PICKER || document.getElementById('oakf-picker')) return;
    // Sit above the product grid, which is where the shopper is heading.
    var grid = document.getElementById('product-grid') ||
               document.querySelector('.collection .product-grid') ||
               document.querySelector('.product-grid');
    var anchor = grid ? (grid.closest('.collection') || grid.parentNode) : null;
    if (!anchor) return;

    var wrap = document.createElement('div');
    wrap.className = 'oakf-picker';
    wrap.id = 'oakf-picker';
    wrap.innerHTML =
      '<p class="oakf-title">Choose your stain color</p>' +
      '<p class="oakf-sub">One color for the whole order. The cabinets below update to show it.</p>' +
      '<div class="oakf-grid" role="group" aria-label="Stain color"></div>' +
      '<p class="oakf-note">On-screen colors are representative, not an exact match. ' +
      'Order a sample door before finalizing.</p>';
    var grid2 = wrap.querySelector('.oakf-grid');
    FINISHES.forEach(function (f) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'oakf-tile';
      b.setAttribute('aria-pressed', 'false');
      b.dataset.code = f.code;
      b.innerHTML = '<figure style="margin:0"><img loading="lazy" alt="' + f.name + ' ' + f.code +
                    '" src="' + f.swatch + '"><figcaption><span class="oakf-name">' + f.name +
                    '</span><span class="oakf-code">' + f.code + '</span></figcaption></figure>';
      b.addEventListener('click', function () { select(f); });
      grid2.appendChild(b);
    });
    anchor.insertBefore(wrap, grid && grid.parentNode === anchor ? grid : anchor.firstChild);
  }

  function markChosen() {
    var f = window.OAK_FINISH_SELECTED;
    qsa('.oakf-tile').forEach(function (b) {
      b.setAttribute('aria-pressed', String(!!f && b.dataset.code === f.code));
    });
  }

  function buildBar() {
    if (document.getElementById('oakf-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'oakf-bar';
    bar.id = 'oakf-bar';
    bar.hidden = true;
    bar.innerHTML =
      '<span class="oakf-bar-label">Your stain:</span>' +
      '<img class="oakf-bar-sw" alt="">' +
      '<span class="oakf-bar-name"></span>' +
      '<span class="oakf-bar-code"></span>' +
      '<span class="oakf-bar-need">Choose your stain color to continue</span>';
    var cta = document.createElement(SHOW_PICKER ? 'button' : 'a');
    cta.className = 'oakf-bar-cta';
    if (SHOW_PICKER) { cta.type = 'button'; cta.addEventListener('click', scrollToPicker); }
    else cta.href = CFG.collectionUrl || '/collections/white-oak-inset-shaker-kitchen-cabinets-special-order';
    bar.appendChild(cta);
    document.body.appendChild(bar);
  }

  function renderBar() {
    var bar = document.getElementById('oakf-bar');
    if (!bar) return;
    var f = window.OAK_FINISH_SELECTED;
    var need = bar.querySelector('.oakf-bar-need');
    var cta = bar.querySelector('.oakf-bar-cta');
    if (!f) {
      if (!REQUIRE) { bar.hidden = true; return; }
      bar.hidden = false;
      bar.querySelector('.oakf-bar-label').style.display = 'none';
      bar.querySelector('.oakf-bar-sw').style.display = 'none';
      need.style.display = '';
      cta.textContent = 'Pick a stain';
      return;
    }
    bar.hidden = false;
    bar.classList.remove('oakf-bar--alert');
    bar.querySelector('.oakf-bar-label').style.display = '';
    var sw = bar.querySelector('.oakf-bar-sw');
    sw.style.display = ''; sw.src = f.swatch;
    need.style.display = 'none';
    bar.querySelector('.oakf-bar-name').textContent = f.name;
    bar.querySelector('.oakf-bar-code').textContent = f.code;
    cta.textContent = 'Change stain';
  }

  function scrollToPicker() {
    var p = document.getElementById('oakf-picker');
    if (p && p.scrollIntoView) p.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function showNeeded() {
    renderBar();
    var bar = document.getElementById('oakf-bar');
    if (bar) bar.classList.add('oakf-bar--alert');
    if (SHOW_PICKER) scrollToPicker();
    else if (bar && bar.scrollIntoView) bar.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ---------- add to cart ------------------------------------------------ */
  function wireSubmit() {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
      if (REQUIRE && !window.OAK_FINISH_SELECTED && !isExempt(f)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showNeeded();
        return;
      }
      injectCartProps();
    }, true);
  }

  function boot() {
    styles();
    buildPicker();
    buildBar();
    renderBar();
    markChosen();
    wireSubmit();
    injectCartProps();
    syncPaymentButtons();
    setInterval(function () { injectCartProps(); syncPaymentButtons(); }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
